export enum AutocompleteMode {
  CREATE = 'create',
  SELECT = 'select',
  EDIT = 'edit',
  CLEAR = 'clear',
}
